import React from 'react';

import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { NPIDataGridColDef } from 'src/components/NPIDataGrid/NPIDataGrid';
import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';
import { formatDate } from 'src/utils/utils';

type CreditsTableColumnDefProps = {
    handleView: ({ id }: { id: number }) => void;
};

const CURRENCY_CONVERSION_FACTOR = 100.0;

const createColumns = ({ handleView }: CreditsTableColumnDefProps): NPIDataGridColDef[] => {
    return [
        {
            field: 'sageCreditNoteNumber',
            headerName: 'Credit Note Number',
        },
        {
            field: 'merchantName',
            headerName: 'Merchant Name',
        },
        {
            field: 'partnerName',
            headerName: 'Partner Name',
        },
        {
            field: 'dateAdded',
            headerName: 'Date Added',
            renderCell: (params: GridRenderCellParams) => {
                if (Number.isFinite(Number(params.value))) {
                    return (
                        <>
                            {params.value &&
                                formatDate({ date: new Date(Number.parseInt(params.value, 10)) })}
                        </>
                    );
                }

                return <>{params.value && formatDate({ date: params.value })}</>;
            },
        },
        {
            field: 'invoiceNumber',
            headerName: 'Invoice Number',
        },
        {
            field: 'creditValue',
            headerName: 'Credit Value',
            renderCell: (params: GridRenderCellParams) => {
                if (params?.value) {
                    return <>{Number(params?.value / CURRENCY_CONVERSION_FACTOR).toFixed(2)}</>;
                }

                return <>-</>;
            },
        },
        {
            field: 'actions',
            disableColumnMenu: true,
            headerName: 'Actions',
            flex: 0,
            minWidth: 160 / 3,
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <IconButton
                        onClick={() => {
                            return handleView({ id: params.row.id });
                        }}
                        aria-label="view"
                    >
                        <VisibilityIcon />
                    </IconButton>
                );
            },
        },
    ];
};

const CreditsTableColumnDef = ({ handleView }: CreditsTableColumnDefProps) => {
    return createColumns({ handleView }).map((column: NPIDataGridColDef) => {
        return createColumnDef(column);
    });
};

export default CreditsTableColumnDef;
